import {
	ViewsPage,
	SearchPage,
	ModelPage,
	DashboardPage,
	ExportsPage,
	RolesPage,
	ProcessPage,
	ImportPage,
	ReportPage,
	ReportDetailPage,
	SharepointPage,
	ExportConfigPage,
	GDPRPage,
} from './pages'
import { withNavigationWatcher } from './contexts/navigation'

const routes = [
	{
		path: '/',
		element: ViewsPage,
	},
	{
		path: '/v/*',
		element: ViewsPage,
	},
	{
		path: '/m/*',
		element: ModelPage,
	},
	{
		path: '/dashboard/*',
		element: DashboardPage,
	},
	{
		path: '/search/*',
		element: SearchPage,
	},
	{
		path: '/processes/*',
		element: ProcessPage,
	},
	{
		path: '/imports/*',
		element: ImportPage,
	},
	{
		path: '/exports',
		element: ExportsPage,
	},
	{
		path: '/export-config/:process',
		element: ExportConfigPage,
	},
	{
		path: '/roles',
		element: RolesPage,
	},
	{
		path: '/reports/*',
		element: ReportPage,
	},
	{
		path: '/report-detail',
		element: ReportDetailPage,
	},
	{
		path: '/sharepoint',
		element: SharepointPage,
	},
	{
		path: '/gdpr/dsar-search',
		element: GDPRPage,
	},
]

export default routes.map(route => {
	return {
		...route,
		element: withNavigationWatcher(route.element, route.path),
	}
})
